import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Modal, message, Upload } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { ServerAPI } from "../../common/ServerAPI";
import { toast } from "react-toastify";
import { IMAGE_BASE_URL } from "../../common/Constants";
import CropPopup from "./CropPopUp";
import axios from "axios";
import { API, dataURItoBlob } from "../../common/Constants";
import { getAuthString } from "../../common/Utilities";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";
import { Tabs } from "antd";

const SignaturePadComponent = ({ visible, onCancel, onSave, Imagetype }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isupload, setIsUpload] = useState(false);
  const [stampUpload, setStampUpload] = useState(false);
  const [url, setUrl] = useState("");
  const [stampUrl, setStampUrl] = useState("");
  const fileInputRefSignature = useRef(null);
  const fileInputRefStamp = useRef(null);
  const [applicantType, setApplicantType] = useState("");
  const [type, setType] = useState("");
  const [showCrop, setShowCrop] = useState(false);
  const [image, setImage] = useState(null);
  const [imageType, setImageType] = useState("");
  const [croppedImage, setCroppedImage] = useState(null);
  let mouseMoveTimeout;
  const { TabPane } = Tabs;

  const handleMouseDown = (event) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = (event.clientX - rect.left) * scaleX;
    const y = (event.clientY - rect.top) * scaleY;

    ctx.beginPath(); // Start a new path
    ctx.arc(x, y, 1, 0, Math.PI * 2); // Draw a small dot at the given (x, y) coordinates
    ctx.fill();
    setIsDrawing(true);
  };

  const handleMouseMove = (event) => {
    if (isDrawing) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const x = (event.clientX - rect.left) * scaleX;
      const y = (event.clientY - rect.top) * scaleY;

      ctx.lineTo(x, y);
      ctx.stroke();
    }
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
    const canvas = canvasRef.current;
    canvas.toBlob(async (blob) => {
      if (blob) {
        clearTimeout(mouseMoveTimeout);
        mouseMoveTimeout = setTimeout(async () => {
          const formData = new FormData();
          formData.append("signature", blob, "signature.png");
          const response = await ServerAPI.fileUpload(
            formData.get("signature")
          );
          if (response && response.resp_code == 200) {
            setUrl(response.data);
          }
        }, 500);
      }
    });
  };

  // const handleClear = () => {
  //   setUrl("");
  //   setStampUrl("");
  //   setStampUpload(false);
  //   setIsUpload(false);
  //   if (!isupload) {
  //     const canvas = canvasRef.current;
  //     const ctx = canvas.getContext("2d");
  //     ctx.clearRect(0, 0, canvas.width, canvas.height);
  //   }
  // };

  const handleClear = () => {
    setUrl("");
    setStampUrl("");
    setStampUpload(false);
    setIsUpload(false);
    if (!isupload) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    } else {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  };


  const handleStartDrawing = (event) => {
    console.log(event.touches);
    event.preventDefault();
    setIsDrawing(true);

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x =
      ((event.touches ? event.touches[0].clientX : event.clientX) - rect.left) *
      scaleX;
    const y =
      ((event.touches ? event.touches[0].clientY : event.clientY) - rect.top) *
      scaleY;

    context.beginPath(); // Start a new path
    context.arc(x, y, 1, 0, Math.PI * 2); // Draw a small dot at the given (x, y) coordinates
    context.fill();
  };

  const handleDrawing = (event) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x =
      ((event.touches ? event.touches[0].clientX : event.clientX) - rect.left) *
      scaleX;
    const y =
      ((event.touches ? event.touches[0].clientY : event.clientY) - rect.top) *
      scaleY;

    context.lineTo(x, y);
    context.stroke();
  };

  const handleEndDrawing = () => {
    setIsDrawing(false);
  };

  const handleFileUpload = async (event, type) => {
    setShowCrop(true);
    setType(type);
    console.log(imageType);
    const files = event.target.files;
    setImage(URL.createObjectURL(files[0]));
  };

  const handleButtonClick = (type) => {
    if (type == "signature") {
      fileInputRefSignature.current.click();
      setImageType("signature");
    } else {
      fileInputRefStamp.current.click();
      setImageType("stamp");
    }
  };

  useEffect(() => {
    let applicantTypeData = localStorage.getItem("applicanttype");
    if (applicantTypeData) {
      setApplicantType(applicantTypeData);
    }
  }, []);

  const imageCropper = async (croppedImage) => {
    const persistAuthString = await getAuthString();
    if (croppedImage) {
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append("file", blobFile, "crop-icon.jpg");
      formData.append("module", "loan_application");
      let fileRes = await axios
        .post(API.BaseUrl + API.EndPoint.uploadImage, formData, {
          headers: {
            Authorization: `Bearer ${persistAuthString}`,
          },
        })
        .then((response) => {
          if (response) {
            if (type == "signature") {
              setIsUpload(true);
              setUrl(response?.data.data);
            } else {
              setStampUpload(true);
              setStampUrl(response?.data.data);
            }
          }
        });
    }
  };

  useEffect(() => {
    imageCropper(croppedImage);
  }, [croppedImage]);

  return (
    <Modal
      style={{ top: "1px" }}
      centered={true}
      width={520}
      open={visible}
      onCancel={() => {
        setUrl("");
        setStampUrl("");
        setStampUpload(false);
        setIsUpload(false);
        if (!isupload) {
          const canvas = canvasRef.current;
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        onCancel();
      }}
      className="mt-[20px]"
      footer={[
        <div className="flex items-center justify-center md:justify-end space-x-4 mt-5">
          <Button
            key="clear"
            className="w-[112px]"
            onClick={() => {
              handleClear();
              onCancel();
            }}
          >
            Back
          </Button>
          <Button
            key="save"
            className="w-[112px]"
            type="primary"
            onClick={() => {
              console.log("ONSAVEVALUES", url, stampUrl)
              onSave(url, stampUrl);
              setTimeout(() => {
                handleClear();
                onCancel();
              }, 1500);

            }}
          >
            Confirm
          </Button>
        </div>,
      ]}
    >
      <div>
        <p className="text-[20px] font-bold mb-5 text-center">Sign Document</p>
        <Tabs defaultActiveKey="1" centered type="card">
          <TabPane tab={"Signature"} key={1}>
            <p className="text-[15px] mb-2 font-[400] signature-instruction">
              Sign in the{" "}
              <span className="text-[15px] font-bold">Box Below</span> or{" "}
              <span className="text-[15px] font-bold">Upload</span> your
              Signature
            </p>
            {!isupload ? (
              <canvas
                className="signature-canvas signature-h"
                ref={canvasRef}
                style={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px",
                  width: "100%",
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseOut={handleMouseUp}
                onTouchStart={handleStartDrawing}
                onTouchMove={handleDrawing}
                onTouchEnd={handleEndDrawing}
              />
            ) : (
              <div
                className="signature-canvas"
                style={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px",
                  height: "200px",
                }}
              >
                <img
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    margin: "auto",
                  }}
                  src={IMAGE_BASE_URL + "/" + url}
                  alt="N/A"
                />
              </div>
            )}
            <div className="flex justify-between items-center mt-3">
              <input
                type="file"
                id="signature"
                style={{ display: "none" }}
                ref={fileInputRefSignature}
                onChange={(e) => {
                  handleFileUpload(e, "signature");
                }}
              />
              <Button
                className="mr-3"
                onClick={() => {
                  handleButtonClick("signature");
                }}
              >
                <p className="flex items-center">
                  <span className="mr-[5px] mt-[-7px]">
                    <UploadOutlined />
                  </span>
                  <span>Upload Signature</span>
                </p>
              </Button>
              <Button
                onClick={() => {
                  setUrl("");
                  setIsUpload(false);
                  if (!isupload) {
                    const canvas = canvasRef.current;
                    const ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                  }
                }}
              >
                <p className="flex items-center">
                  <span className="mr-[5px] mt-[-7px]">
                    <DeleteOutlined />
                  </span>
                  <span>Clear</span>
                </p>
              </Button>
            </div>
          </TabPane>
          <TabPane tab={"Stamp"} key={2}>
            <Fragment>
              <p className="text-[15px] mb-2 font-[400] signature-instruction">
                <span className="text-[15px] font-bold">Company Stamp</span> is
                required if you are a Company
              </p>
              <div>
                <input
                  type="file"
                  id="stamp"
                  style={{ display: "none" }}
                  ref={fileInputRefStamp}
                  onChange={(e) => {
                    handleFileUpload(e, "stamp");
                  }}
                />
                {!stampUpload ? (
                  <div
                    className="signature-canvas text-center h-[158px]"
                    style={{ border: "1px solid #E0E0E0", borderRadius: "8px" }}
                  >
                    <Button
                      className="mt-5 mb-5 mt-[20px] text-step-color-active border border-step-color-active"
                      onClick={() => {
                        handleButtonClick("stamp");
                      }}
                    >
                      <p className="flex">
                        <p className="mt-[-2px] mr-[5px]">
                          <UploadOutlined />
                        </p>
                        <p>Upload Company Stamp</p>
                      </p>
                    </Button>
                  </div>
                ) : (
                  <Fragment>
                    <div
                      className="signature-canvas"
                      style={{
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        height: "200px",
                      }}
                    >
                      <img
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          margin: "auto",
                        }}
                        src={IMAGE_BASE_URL + "/" + stampUrl}
                        alt="N/A"
                      />
                    </div>
                    <div className="flex justify-between items-center mt-3">
                      <Button
                        className="text-step-color-active border border-step-color-active"
                        onClick={() => {
                          handleButtonClick("stamp");
                        }}
                      >
                        <p className="flex items-center">
                          <span className="mr-[5px] mt-[-10px]">
                            <UploadOutlined />
                          </span>
                          <span>Upload Stamp</span>
                        </p>
                      </Button>
                      <Button
                        onClick={() => {
                          setStampUrl("");
                          setStampUpload(false);
                        }}
                      >
                        <p className="flex items-center">
                          <span className=" mt-[-10px] mr-[5px]">
                            <DeleteOutlined />
                          </span>
                          <span>Clear</span>
                        </p>
                      </Button>
                    </div>
                  </Fragment>
                )}
              </div>
            </Fragment>
          </TabPane>
        </Tabs>
      </div>
      {showCrop && (
        <CropPopup
          image={image}
          setActive={() => {
            setShowCrop(false);
          }}
          setImage={setCroppedImage}
          Imagetype={imageType}
        />
      )}
    </Modal>
  );
};

export default SignaturePadComponent;
